import { ButtonLink } from '@/components/ui/Link';
import { Customer } from '@/generated/graphql';
import { createSortingButton } from '@/utils/table.function';
import { ColumnDef } from '@tanstack/react-table';
import { Navigation } from 'lucide-react';

export const customerColumns: ColumnDef<Customer>[] = [
  {
    accessorKey: 'name',
    header: ({ column }) => {
      return createSortingButton(column, 'Name');
    },
    size: 200,
  },

  {
    accessorKey: 'devices',
    header: 'Number of Device',
    cell: ({ row }) =>
      (row?.original?.sites ?? []).reduce((sum, site) => {
        return sum + (site.devicesAggregate?.aggregate?.count || 0);
      }, 0),
    size: 100,
  },
  {
    accessorKey: 'action',
    header: '',
    cell: ({ row }) => (
      <ButtonLink
        variant="outline"
        size={'icon-sm'}
        className="ms-auto flex"
        to={`${row.original.id}`}
      >
        <Navigation />
      </ButtonLink>
    ),
  },
];
